import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './TermsAndConditions.css'; // Import the CSS file for custom styles

const TermsAndConditions = () => {
  const [agreed, setAgreed] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const navigate = useNavigate();

  const handleAgree = () => {
    if (agreed && name && email && phone) {
      // Pass the user details as state while navigating
      navigate('/sourcing', { state: { name, email, phone } });
    } else {
      alert('Please agree to the terms and conditions and fill out all the fields before proceeding.');
    }
  };

  return (
    <div className="locator-container">
      <h1 className="locator-title">Car Locator Service</h1>
      <p className="locator-description">Please fill in the details below, agree to the terms, and we will help you find your perfect car!</p>
      
      <form className="locator-form">
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input 
            type="text" 
            id="name" 
            value={name} 
            onChange={(e) => setName(e.target.value)} 
            placeholder="Enter your name" 
            required 
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input 
            type="email" 
            id="email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            placeholder="Enter your email" 
            required 
          />
        </div>

        <div className="form-group">
          <label htmlFor="phone">Phone:</label>
          <input 
            type="tel" 
            id="phone" 
            value={phone} 
            onChange={(e) => setPhone(e.target.value)} 
            placeholder="Enter your phone number" 
            required 
          />
        </div>

        <div className="terms-section">
          <h2>Terms and Conditions</h2>
          <div className="terms-text">
            <p>By using our car sourcing services, you agree to the following terms:</p>
            <ol>
              <li>Provide accurate information (name, email, phone) at all times.</li>
              <li>Agree to all terms and conditions before proceeding.</li>
              <li>We respect your confidentiality; your data is used solely for sourcing purposes.</li>
              <li>The service is an intermediary and is not liable for post-purchase issues.</li>
              <li>Eligibility: Users must be of legal age and able to enter into a vehicle agreement.</li>
              <li>No liability for errors caused by third parties such as car dealerships.</li>
              <li>Prohibited activities include fraudulent activity or manipulating vehicle pricing.</li>
              <li>Service fees may apply for additional support, disclosed upfront.</li>
              <li>The service is provided "as is" without warranties.</li>
            </ol>
          </div>
          <div className="agree-container">
            <input 
              type="checkbox" 
              id="agree" 
              checked={agreed} 
              onChange={() => setAgreed(!agreed)} 
            />
            <label htmlFor="agree">I agree to the terms and conditions</label>
          </div>
        </div>

        <button type="button" onClick={handleAgree} className="submit-btn">
          Proceed to Car Sourcing Form
        </button>
      </form>
    </div>
  );
};

export default TermsAndConditions;
